export default __webpack_public_path__ + "static/media/office2-afterB-480w.0c1783a6.webp";